import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import { Box } from "@mui/material";
import { StatusInactiveIcon } from "src/foundations/icons/index";

export const StatusActiveIcon = (props: SvgIconProps) => {
    return (
        <Box
            data-testid={"status-active-icon"}
            sx={{ position: "relative", display: "inline-flex", alignItems: "center", justifyContent: "center" }}
        >
            <StatusInactiveIcon />
            <OverlayCircle {...props} sx={{ position: "absolute" }} />
        </Box>
    );
};

const OverlayCircle = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none" {...props}>
                <path
                    stroke="#009"
                    strokeLinecap="round"
                    strokeWidth={2}
                    d="M11 0.99996C12.8442 0.99996 14.6525 1.50995 16.225 2.47356C17.7975 3.43716 19.0728 4.81684 19.9101 6.46006C20.7473 8.10327 21.1139 9.94601 20.9692 11.7846C20.8245 13.6231 20.1742 15.3858 19.0902 16.8778C18.0062 18.3698 16.5307 19.533 14.8268 20.2388C13.123 20.9445 11.2572 21.1653 9.43567 20.8768C7.61415 20.5883 5.90789 19.8017 4.50553 18.604C3.10317 17.4063 2.05934 15.8441 1.48945 14.0901"
                />
            </svg>
        </SvgIcon>
    );
};
